export function getStageByDomain() {
  const url = window.location.hostname
  // Determine deployment stage by browser's location
  if (url.indexOf('localhost') > -1) return 'local'; // 'localhost:8005';
  if (url.indexOf('dev.') > -1) return 'dev'; // dev.realm-global.com
  if (url.indexOf('staging.') > -1) return 'staging'; // 'staging.realm-global.com'
  return 'prod'; // `agent.realm-global.com/`
}
